import Grid from '~components/_layout/Grid/Grid';

import ValuePropImage from './child-blocks/ValuePropImage';

type Props = {
    template?: string;
    valuepropimagemobile?: string;
    valuepropimagetablet?: string;
    valuepropimagedesktop?: string;
};

const ZeroPremiumsValueProp = ({
    template = 'shop',
    valuepropimagemobile,
    valuepropimagetablet,
    valuepropimagedesktop,
    children,
}: React.PropsWithChildren<Props>) => (
    <section className="py-24">
        <Grid>
            {/* Value Prop Image */}
            <div className="col-span-4 md:col-span-4 lg:col-span-6">
                <ValuePropImage
                    images={{
                        sm: valuepropimagemobile,
                        md: valuepropimagetablet,
                        lg: valuepropimagedesktop,
                    }}
                />
            </div>

            {/* Value Prop Content */}
            <div className="col-span-4 md:col-span-4 lg:col-span-6 mt-8 md:mt-0">
                <div className="lg:mt-14 text-center lg:text-left">
                    <div>{children}</div>

                    <div className="mt-12">
                        <a
                            className="text-white bg-[#FA6200] rounded-full font-poppins font-bold text-20 px-12 py-3"
                            href={process.env.GATSBY_EHMP_URL}
                        >
                            Compare $0 Premium Plans
                        </a>
                    </div>
                </div>
            </div>
        </Grid>
    </section>
);

export default ZeroPremiumsValueProp;
